export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const CLIENT_ID = process.env.REACT_APP_MS_CLIENT_ID;
export const TENANT_ID = process.env.REACT_APP_MS_TENANT_ID;
